import AnswerComponent from "../active-game/AnswerComponent";


export default function InactiveAnswerTable({game}) {
    return(
        <div id="answer-table" className="vertical-container top-margin">
          <table ><tbody >
          {[...Array(10).keys()].map(i => 
            <tr key={i} className="horizontal-container padding">
              <td className="fixed-container right-border">
                <AnswerComponent answers={game?.answers} index={i} />
              </td>
              <td className="fixed-container padding-left">
                {i+10<19 && 
                  <AnswerComponent answers={game?.answers} index={i+10} />
                }
              </td>
            </tr>
          )}
          </tbody></table>
        </div> 
    )
}